import { combineReducers } from 'redux';
import app from './App/reducer';
import activeGame from './ActiveGame/reducer';
import attackButton from './AttackButton/reducer';
import card from './Card/reducer';
import cards from './Cards/reducer';
import coins from './Coins/reducer';
import confirmButton from './ConfirmButton/reducer';
import deck from './Deck/reducer';
import decks from './Decks/reducer';
import gameStart from './GameStart/reducer';
import games from './Games/reducer';
import gameLog from './GameLog/reducer';
import hand from './Hand/reducer';
import login from './Login/reducer';
import passButton from './PassButton/reducer';
import pokemon from './Pokemon/reducer';
import prizes from './Prizes/reducer';
import passwordReset from './PasswordReset/reducer';
import retreatButton from './RetreatButton/reducer';
import undo from './Undo/reducer';
import { reducer as presence } from './Presence';
import profile from './Profile/reducer';
import watch from './Watch/reducer';
import rules from './Rules/reducer';
import picks from './Picks/reducer';
import push from './Push/reducer';
import trainer from './Trainer/reducer';
import users from './Users/reducer';
import notices from './Notices/reducer';
import newMoves from './NewMoves/reducer';
import { LOGOUT } from './Login/constants';

const appReducer = combineReducers({
  // core reducers (not to reset with APP_RESET)
  app,
  login,
  // The card and deck catalogs: the same everywhere and loaded once. A page asks for them as it opens, before the
  // route change's reset runs (a parent's effect runs after its children's), so resetting them lost them.
  cards,
  decks,
  // The game notice banner: it outlives the page it arrived on.
  notices,
  // How many games have moves you haven't seen: the menu's dot, on every page.
  newMoves,

  // reducers to reset with APP_RESET
  activeGame,
  attackButton,
  card,
  coins,
  confirmButton,
  deck,
  gameStart,
  games,
  gameLog,
  hand,
  passButton,
  pokemon,
  prizes,
  passwordReset,
  retreatButton,
  undo,
  presence,
  profile,
  watch,
  rules,
  picks,
  push,
  trainer,
  users,
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined; // reset the app state
  }
  return appReducer(state, action);
};

export default rootReducer;
